import { Router, NavigationEnd } from '@angular/router';
import { LoginService } from './../../services/login/login.service';
import { Component } from '@angular/core';
import { DashboardConcentracionFondoComponent } from './dashboard-concentracion-fondo/dashboard-concentracion-fondo.component';
import { MessagesStatus, MessagesTitles } from 'app/models/messages';

@Component({
  selector: 'app-concentracion-fondo',
  templateUrl: './concentracion-fondo.component.html',
  styleUrls: ['./concentracion-fondo.component.scss'],
  providers:[DashboardConcentracionFondoComponent,MessagesTitles, MessagesStatus]
})
export class ConcentracionFondoComponent {
  url = '';

  constructor(private loginService: LoginService, private router: Router,
    private concentracion:DashboardConcentracionFondoComponent) {
    router.events.subscribe((route) => {
      if (route instanceof NavigationEnd) {
        this.url = route.url;
      }
    });
  }

  clickGuard() {
    this.loginService.clickGuard = true;
  }
  ExportTOExcel() {
    this.concentracion.ExportTOExcel()
  }
}
